import useEmblaCarousel, {
  UseEmblaCarouselType,
} from "embla-carousel-react/components/useEmblaCarousel";
import { useCallback, useEffect } from "react";

const useEmblaSliderFeatures = (
  emblaApi: ReturnType<typeof useEmblaCarousel>[1],
  selectedIndex?: number,
  setSelectedIndex?: (selectedIndex: number) => void,
  setisLastSlide?: (isLastSlide: boolean) => void,
) => {
  const SelectedSlide = selectedIndex && selectedIndex < 0 ? 0 : selectedIndex;
  if (emblaApi && selectedIndex) {
    emblaApi.scrollTo(SelectedSlide!);
  }
  const SlidesInView = useCallback(
    (emblaApi: UseEmblaCarouselType[1] | undefined) => {
      if (!emblaApi) return;
      const maxSlideIdx = emblaApi?.slideNodes()?.length - 1;
      const isLastSlideInView = emblaApi?.slidesInView().includes(maxSlideIdx);
      if (isLastSlideInView && setisLastSlide) {
        setisLastSlide(true);
      }
    },
    [setisLastSlide],
  );
  const onSlideChage = useCallback(() => {
    if (emblaApi && setSelectedIndex)
      setSelectedIndex(emblaApi?.internalEngine()?.index.get()!);
  }, [emblaApi, setSelectedIndex]);
  const onScrollTo = useCallback(() => {
    if (!emblaApi || !selectedIndex) return;
    emblaApi.scrollTo(SelectedSlide!);
  }, [SelectedSlide, emblaApi, selectedIndex]);
  useEffect(() => {
    if (emblaApi) {
      emblaApi?.on("slidesInView", SlidesInView);
      emblaApi.on("slidesChanged", onScrollTo);
      emblaApi.on("select", onSlideChage);
    }
  }, [SlidesInView, emblaApi, onScrollTo, onSlideChage]);
};
export default useEmblaSliderFeatures;
